import React, { useState, useEffect } from 'react';
import Consola from './Consola'; 
import Tutorial from './Tutorial';
import Sqlcontent from './Sqlcontent';
import RemoteContent from './RemoteContent';
import { generarUUID } from './generadorUUID';
import LoginModal from './Login';

const Dashboard: React.FC = () => {
  const [activeSection, setActiveSection] = useState<'dashboard' | 'terminal' | 'sql' | 'remote'>('dashboard');
  const [sessionUUID, setSessionUUID] = useState<string | null>(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    let storedUUID = localStorage.getItem('sessionUUID');
    if (!storedUUID) {
      storedUUID = generarUUID();
      localStorage.setItem('sessionUUID', storedUUID);
    }
    setSessionUUID(storedUUID);
    console.log(`UUID de la sesión: ${storedUUID}`);
  }, []);

  // Cerrar sidebar automáticamente en desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Control de clase en body cuando sidebar está abierto
  useEffect(() => {
    if (sidebarOpen) {
      document.body.classList.add('sidebar-open');
    } else {
      document.body.classList.remove('sidebar-open');
    }
  }, [sidebarOpen]);

  const regenerateUUID = () => {
    const currentUUID = localStorage.getItem('sessionUUID');
    const newUUID = generarUUID();
    
    if (currentUUID !== newUUID) {
      localStorage.setItem('sessionUUID', newUUID);
      setSessionUUID(newUUID);
      console.log(`Nuevo UUID generado manualmente: ${newUUID}`);
    } else {
      console.log('El UUID no ha cambiado, no se genera un nuevo UUID.');
    }
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const handleNavClick = (section: 'dashboard' | 'terminal' | 'sql' | 'remote') => {
    setActiveSection(section);
    closeSidebar();
  };

  return (
    <div className="wrapper">
      {/* Botón hamburguesa */}
      {!sidebarOpen && (
        <button 
          className="mobile-menu-toggle" 
          onClick={toggleSidebar}
          aria-label="Toggle menu"
        >
          <i className="fas fa-bars"></i>
        </button>
      )}

      {/* Overlay oscuro */}
      <div 
        className={`sidebar-overlay ${sidebarOpen ? 'active' : ''}`}
        onClick={closeSidebar}
      ></div>

      {/* Barra lateral */}
      <aside className={`main-sidebar sidebar-dark-primary elevation-4 ${sidebarOpen ? 'active' : ''}`}>
        <button 
          className="sidebar-close" 
          onClick={closeSidebar}
          aria-label="Close menu"
        >
          <i className="fas fa-times"></i>
        </button>

        <a href="/" className="brand-link">
          <span className="brand-text font-weight-light">AdminLTE</span>
        </a>
        <div className="sidebar">
          <nav className="mt-2">
            <ul className="nav nav-pills nav-sidebar flex-column" role="menu">
              <li className="nav-item">
                <a href="#" className={`nav-link ${activeSection === 'dashboard' ? 'active' : ''}`}
                  onClick={() => handleNavClick('dashboard')}>
                  <i className="nav-icon fas fa-chalkboard-teacher"></i>
                  <p>Tutorial</p>
                </a>
              </li>

              <li className="nav-item">
                <a href="#" className={`nav-link ${activeSection === 'terminal' ? 'active' : ''}`}
                  onClick={() => handleNavClick('terminal')}>
                  <i className="nav-icon fas fa-terminal"></i>
                  <p>Terminal</p>
                </a>
              </li>

              <li className="nav-item">
                <a href="#" className={`nav-link ${activeSection === 'sql' ? 'active' : ''}`}
                  onClick={() => handleNavClick('sql')}>
                  <i className="nav-icon fas fa-magic"></i>
                  <p>Form Wizard</p>
                </a>
              </li>

              <li className="nav-item">
                <a href="#" className={`nav-link ${activeSection === 'remote' ? 'active' : ''}`}
                  onClick={() => handleNavClick('remote')}>
                  <i className="nav-icon fas fa-server"></i>
                  <p>Remote Connection</p>
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="#"
                  className="nav-link"
                  onClick={() => {
                    closeSidebar();
                    const modalElement = document.getElementById('loginModal');
                    if (modalElement) {
                      const modal = new window.bootstrap.Modal(modalElement);
                      modal.show();
                    } else {
                      console.error("El modal con id 'loginModal' no fue encontrado en el DOM.");
                    }
                  }}
                >
                  <i className="nav-icon fas fa-download"></i>
                  <p>Descargar Proyecto</p>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </aside>

      {/* Contenido principal */}
      <div className="content-wrapper" style={{ overflow: 'visible', height: 'auto' }}>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1>
                  {activeSection === 'dashboard' ? 'Tutorial' : 
                   activeSection === 'terminal' ? 'Terminal' : 
                   activeSection === 'sql' ? 'SQL' : 'Remote Connection'}
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content" style={{ overflow: 'visible', height: 'auto' }}>
          <div className="container-fluid" style={{ overflow: 'visible', height: 'auto' }}>
            {activeSection === 'dashboard' && <Tutorial />}
            {activeSection === 'terminal' && <Consola />}
            {activeSection === 'sql' && <Sqlcontent />}
            {activeSection === 'remote' && <RemoteContent />}
          </div>
        </section>
      </div>

      <LoginModal />
    </div>
  );
};

export default Dashboard;